/* bundle.js: client interactivity for the Lumaray bundle buy-box (OS 2.0 port).
 *
 * Ported from lumaray-pdp/bundle-pdp.js + the render helpers of bundle-render.js.
 * The synthetic localStorage cart is REMOVED. Everything is wired to the REAL
 * Shopify AJAX cart via window.LumarayCart.add(variantId, qty).
 *
 * Data source: each .lrbp[data-handle] root contains
 *   <script type="application/json" data-lrbp-model> { ...resolved model... } </script>
 * populated server-side by main-product.liquid from LIVE Shopify objects
 * (all_products[handle].selected_or_first_available_variant.id / price / compare_at etc).
 * So NO variant IDs are hardcoded here; they come from Liquid.
 *
 * Model shape:
 *   { handle, hasTiers,
 *     products: { handle: {title,short,img,price,compareAt,variant,rating,reviewCount,kicker} },
 *     tiers: [ {id,name,tagline,items:[handle],price,badge,gifts:[handle]} ],
 *     fbt: [handle],            // companion accessories (wipes + headband)
 *     defaultTierId }
 * price/compareAt are DOLLARS (AUD). variant is a numeric variant id.
 */
(function () {
  'use strict';

  function money(n) { return '$' + Number(n).toLocaleString('en-AU'); }
  function money2(n) {
    var r = Math.round(n * 100) / 100;
    return '$' + r.toLocaleString('en-AU', { minimumFractionDigits: r % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c];
    });
  }

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
  var STAR_SM = '<svg viewBox="0 0 24 24" fill="currentColor" width="11" height="11"><path d="M12 2l2.9 6.3 6.9.6-5.2 4.6 1.6 6.8L12 17.3 5.8 20.9l1.6-6.8L2.2 8.9l6.9-.6z"/></svg>';

  function cartReady() { return !!(window.LumarayCart && typeof window.LumarayCart.add === 'function'); }

  function init(root) {
    if (!root || root.getAttribute('data-lrbp-wired') === '1') return;
    root.setAttribute('data-lrbp-wired', '1');

    var modelEl = root.querySelector('[data-lrbp-model]');
    if (!modelEl) return;
    var M;
    try { M = JSON.parse(modelEl.textContent); } catch (e) { return; }
    if (!M || !M.handle) return;

    var handle = M.handle;
    var P = M.products || {};
    var hasTiers = !!M.hasTiers;
    var tiers = M.tiers || [];
    var product = P[handle];
    if (!product) return;

    function tierById(id) { return tiers.filter(function (t) { return t.id === id; })[0] || null; }
    function giftHandlesFor() { return (M.fbt || []).filter(function (h) { return P[h]; }); }
    function isBundleTier(t) { return !!(t && t.items && t.items.length > 1); }

    // total-savings math, mirrors bundle-render.tierValue()
    function tierValue(tier) {
      var giftHandles = giftHandlesFor();
      var isB = tier.items.length > 1;
      var giftSum = (isB && giftHandles.length)
        ? giftHandles.reduce(function (t, h) { return t + (P[h] ? P[h].price : 0); }, 0)
        : 0;
      var was = isB
        ? tier.items.reduce(function (t, h) { return t + (P[h] ? P[h].compareAt : 0); }, 0) + giftSum
        : product.compareAt;
      var save = was - tier.price;
      return { isBundle: isB, giftSum: giftSum, was: was, save: save, pct: was > 0 ? Math.round(save / was * 100) : 0 };
    }

    // ---- element handles ----
    var heroImg = root.querySelector('[data-hero-img]');
    var heroSave = root.querySelector('[data-hero-save]');
    var thumbsEl = root.querySelector('[data-thumbs]');
    var priceNow = root.querySelector('[data-price-now]');
    var priceWas = root.querySelector('[data-price-was]');
    var pillSave = root.querySelector('[data-pill-save]');
    var afterpayEl = root.querySelector('[data-afterpay]');
    var afterpaySmall = root.querySelector('[data-afterpay-small]');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var savingsCard = root.querySelector('[data-savings-card]');
    var savingsAmt = root.querySelector('[data-savings-amt]');
    var savingsFill = root.querySelector('[data-savings-fill]');
    var savingsSteps = root.querySelector('[data-savings-steps]');
    var tiersEl = root.querySelector('[data-tiers]');
    var fbtEl = root.querySelector('#lrbpFbt');
    var cta = root.querySelector('#lrbpCta');

    // ---- initial selected-tier state ----
    // The server has already painted a default tier (the "Most loved" middle tier when bundles
    // exist, else the single tier) and marked it with .is-sel / a checked radio. Bind the JS
    // `selected` state to THAT server default so the Add button label/price and the add action
    // always match what the shopper sees on load. Resolution order:
    //   1) the tier the server rendered as checked/selected (source of truth for the paint),
    //   2) the model's defaultTierId,
    //   3) the first tier (never leave `selected` undefined -> never fall back to hero-only).
    function serverSelectedTier() {
      if (!tiersEl) return null;
      var el = tiersEl.querySelector('.tier.is-sel, .tier[aria-checked="true"]');
      if (!el) { var checked = tiersEl.querySelector('input[type="radio"]:checked'); el = checked && checked.closest('.tier'); }
      return el ? tierById(el.getAttribute('data-tier-id')) : null;
    }
    var selected = serverSelectedTier() || tierById(M.defaultTierId) || tiers[0] || null;

    // accessory-checked map for the FBT single-tier path (default: all preselected)
    var optChecked = {};
    (M.fbt || []).forEach(function (h) { if (P[h]) optChecked[h] = true; });

    // ============ GALLERY (thumbs + chevrons + swipe + keyboard, scrolling strip) ============
    if (thumbsEl && heroImg) {
      var thumbBtns = [].slice.call(thumbsEl.querySelectorAll('.thumb'));
      var frame = root.querySelector('[data-hero-frame]');
      var cur = 0;
      function centerThumb(btn) {
        if (!btn) return;
        var target = btn.offsetLeft - (thumbsEl.clientWidth - btn.clientWidth) / 2;
        try { thumbsEl.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { thumbsEl.scrollLeft = target; }
      }
      function select(i) {
        if (!thumbBtns.length) return;
        i = (i % thumbBtns.length + thumbBtns.length) % thumbBtns.length;
        cur = i;
        var btn = thumbBtns[i], img = btn.querySelector('img');
        if (img) heroImg.src = img.getAttribute('data-full') || img.getAttribute('src');
        thumbBtns.forEach(function (t, j) { t.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        centerThumb(btn);
      }
      thumbBtns.forEach(function (btn, i) { btn.addEventListener('click', function () { select(i); }); });
      var gp = root.querySelector('[data-gprev]'), gn = root.querySelector('[data-gnext]');
      if (gp) gp.addEventListener('click', function () { select(cur - 1); });
      if (gn) gn.addEventListener('click', function () { select(cur + 1); });
      if (frame) {
        frame.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); select(cur - 1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); select(cur + 1); }
        });
        var tX = 0, tY = 0, tA = false;
        frame.addEventListener('touchstart', function (e) { var t = e.changedTouches[0]; tX = t.clientX; tY = t.clientY; tA = true; }, { passive: true });
        frame.addEventListener('touchend', function (e) {
          if (!tA) return; tA = false;
          var t = e.changedTouches[0], dx = t.clientX - tX, dy = t.clientY - tY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) select(dx < 0 ? cur + 1 : cur - 1);
        }, { passive: true });
      }
    }

    // ============ PRICE / TIER APPLY ============
    var maxPct = tiers.reduce(function (m, t) { return Math.max(m, tierValue(t).pct); }, 0);

    function applyPrice(tier) {
      selected = tier;
      var tv = tierValue(tier);
      var was = tv.was, save = tv.save;

      if (priceNow) priceNow.textContent = money(tier.price);
      if (priceWas) { priceWas.textContent = money(was); priceWas.style.display = save > 0 ? '' : 'none'; }
      if (pillSave) {
        pillSave.textContent = save > 0 ? ('Save ' + money(save)) : '';
        pillSave.style.display = save > 0 ? '' : 'none';
      }
      if (heroSave) {
        heroSave.textContent = save > 0 ? ('Save ' + money(save)) : '';
        heroSave.style.display = save > 0 ? '' : 'none';
      }

      var apEach = Math.round((tier.price / 4) * 100) / 100;
      if (afterpayEl) {
        afterpayEl.innerHTML = '<span class="ap-txt">Or 4 interest-free payments of <b>' + money2(apEach) + '</b> with</span>' +
          '<span class="ap-brand">Afterpay' +
            '<img class="ap-logo" src="' + M.afterpayLogo + '" alt="Afterpay">' +
            '<span class="ap-info" tabindex="0" role="button" aria-label="What is Afterpay?">i' +
              '<span class="ap-tip" role="tooltip">Afterpay splits your purchase into 4 interest-free payments, due every 2 weeks. No interest, ever. Late fees may apply, and approval is subject to Afterpay’s terms.</span>' +
            '</span>' +
          '</span>';
      }
      if (afterpaySmall) afterpaySmall.textContent = '4 payments of ' + money2(apEach);
      if (ctaPrice) ctaPrice.textContent = '· ' + money(tier.price);

      updateSavingsBar(tier, tv);
      updateSticky(tier, tv);
    }

    function updateSavingsBar(tier, tv) {
      if (!hasTiers || !savingsCard) return;
      // fill tracks the selected tier's POSITION in the progression (tier 1 of N = 1/N ... tier N = full),
      // so bundling more visibly fills more. (Old logic used savings%/max% which bunched every tier near full.)
      var idx = -1;
      for (var k = 0; k < tiers.length; k++) { if (tiers[k].id === tier.id) { idx = k; break; } }
      var fillPct = (tiers.length > 0 && idx >= 0) ? ((idx + 1) / tiers.length * 100) : 0;
      if (savingsFill) savingsFill.style.width = fillPct + '%';
      if (savingsAmt) {
        savingsAmt.innerHTML = tv.save > 0
          ? (money(tv.save) + ' off <span class="pct">(' + tv.pct + '%)</span>')
          : 'Add a companion to unlock <span class="pct">a bigger saving</span>';
      }
      if (savingsSteps) {
        Array.prototype.forEach.call(savingsSteps.querySelectorAll('b'), function (b) {
          b.classList.toggle('on', b.getAttribute('data-tier') === tier.id);
        });
      }
    }

    // ============ FBT (re-render body from model) ============
    function fbtInnerHTML(tier) {
      var companionHandles = giftHandlesFor();
      var bundling = isBundleTier(tier);
      var ritual = (tier && tier.items && tier.items.length) ? tier.items.slice() : [handle];
      var acc = companionHandles.filter(function (h) { return ritual.indexOf(h) === -1; });

      var items = ritual.map(function (h) { return { h: h, kind: 'ritual' }; })
        .concat(acc.map(function (h) { return { h: h, kind: bundling ? 'free' : 'opt' }; }));
      function isOn(it) { return it.kind !== 'opt' ? true : optChecked[it.h] !== false; }

      var stripHtml = items.map(function (it, i) {
        var p = P[it.h];
        var op = i > 0 ? '<span class="fs-op" aria-hidden="true">+</span>' : '';
        return op + '<div class="fs-item' + (isOn(it) ? '' : ' off') + '">' +
          '<div class="fs-ph"><img src="' + esc(p.img) + '" alt="" loading="lazy">' +
          '<span class="fs-check">' + CHECK + '</span></div>' +
          '<div class="fs-name">' + esc(p.short) + '</div></div>';
      }).join('');

      var listHtml = items.map(function (it) {
        var p = P[it.h];
        var isRitual = it.kind === 'ritual', isFree = it.kind === 'free', isOpt = it.kind === 'opt';
        var locked = isRitual || isFree;
        var checked = isOn(it);
        var note = isRitual ? '<span class="this">In your ritual</span> &middot; '
          : isFree ? '<span class="this" style="color:var(--ok)">Free with your bundle</span> &middot; '
          : '';
        var priceHtml = isFree
          ? '<s>' + money(p.price) + '</s> <span class="free">FREE</span>'
          : '<span class="p">' + money(p.price) + '</span>';
        return '<div class="fbt-row' + (locked ? ' locked' : '') + '" data-acc="' + (isOpt ? esc(it.h) : '') + '">' +
          '<button class="fbt-cb" role="checkbox" aria-checked="' + (checked ? 'true' : 'false') + '"' +
            (locked ? ' disabled aria-label="Included"' : ' aria-label="' + (checked ? 'Remove ' : 'Add ') + esc(p.title) + '"') + '>' + CHECK + '</button>' +
          '<span class="fbt-thumb"><img src="' + esc(p.img) + '" alt="" loading="lazy"></span>' +
          '<span class="fbt-info"><span class="n">' + esc(p.title) + '</span>' +
            '<span class="k">' + note +
            '<span style="color:var(--gold);font-weight:700">' + STAR_SM + ' ' + Number(p.rating).toFixed(1) + '</span> &middot; ' +
            Number(p.reviewCount).toLocaleString('en-AU') + ' reviews</span></span>' +
          '<span class="fbt-price">' + priceHtml + '</span>' +
        '</div>';
      }).join('');

      var savePillHtml = bundling
        ? '<span class="fsave" data-fbt-save-pill>' + (acc.length ? 'Wipes + Headband free' : 'Bundle bonus') + '</span>'
        : '<span class="fsave" data-fbt-save-pill style="display:none"></span>';
      var subText = bundling
        ? 'Your bundle, with the companions included free. It all adds to your cart in one tap.'
        : 'Your device, plus optional finishing touches. Untick anything you would rather skip, then add your order below.';

      var ritualSub = ritual.reduce(function (t, h) { return t + P[h].price; }, 0);
      var totalsHtml = '', total;
      if (bundling) {
        var giftVal = acc.reduce(function (t, h) { return t + P[h].price; }, 0);
        var subtotal = ritualSub + giftVal;
        total = tier.price;
        var saving = subtotal - total;
        var n = ritual.length + acc.length;
        totalsHtml += '<div class="fbt-line"><span>Subtotal (' + n + ' items)</span><span>' + money2(subtotal) + '</span></div>';
        if (saving > 0) totalsHtml += '<div class="fbt-line discount"><span>Bundle saving + free gifts</span><span>-' + money2(saving) + '</span></div>';
        totalsHtml += '<div class="fbt-line total"><span class="lbl">Order total</span><span class="val"><span class="was">' + money2(subtotal) + '</span>' + money2(total) + '</span></div>';
      } else {
        var chosenAcc = acc.filter(function (h) { return optChecked[h] !== false; });
        var accCost = chosenAcc.reduce(function (t, h) { return t + P[h].price; }, 0);
        total = ritualSub + accCost;
        var sn = ritual.length + chosenAcc.length;
        totalsHtml += '<div class="fbt-line"><span>Subtotal (' + sn + ' item' + (sn === 1 ? '' : 's') + ')</span><span>' + money2(total) + '</span></div>';
        totalsHtml += '<div class="fbt-line total"><span class="lbl">Order total</span><span class="val">' + money2(total) + '</span></div>';
      }

      return '<div class="fbt-head">' +
          '<span class="ft">Complete the ritual</span>' + savePillHtml +
        '</div>' +
        '<div class="fbt-sub" data-fbt-sub>' + esc(subText) + '</div>' +
        '<div class="fbt-strip" data-fbt-strip>' + stripHtml + '</div>' +
        '<div class="fbt-list" data-fbt-list>' + listHtml + '</div>' +
        '<div class="fbt-foot">' +
          '<div class="fbt-totals" data-fbt-totals>' + totalsHtml + '</div>' +
          '<button class="fbt-add" id="lrbpFbtAdd" type="button">' +
            '<span class="fa-label">Add to cart</span>' +
            '<span class="count" data-fbt-count>· ' + money2(total) + '</span>' +
          '</button>' +
        '</div>';
    }
    function renderFbt() { if (fbtEl && selected) fbtEl.innerHTML = fbtInnerHTML(selected); }

    // ============ TIER SELECTION ============
    if (hasTiers && tiersEl) {
      var selectTier = function (label) {
        var id = label.getAttribute('data-tier-id');
        var tier = tierById(id);
        if (!tier) return;
        Array.prototype.forEach.call(tiersEl.querySelectorAll('.tier'), function (t) {
          t.classList.remove('is-sel'); t.setAttribute('aria-checked', 'false');
          var inp = t.querySelector('input'); if (inp) inp.checked = false;
        });
        label.classList.add('is-sel'); label.setAttribute('aria-checked', 'true');
        var input = label.querySelector('input'); if (input) input.checked = true;
        applyPrice(tier);
        renderFbt();
      };
      tiersEl.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;
        var label = input.closest('.tier');
        if (label) selectTier(label);
      });
      tiersEl.addEventListener('click', function (e) {
        var label = e.target.closest('.tier');
        if (!label || label.classList.contains('is-sel')) return;
        selectTier(label);
      });
      tiersEl.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var label = e.target.closest('.tier');
        if (!label) return;
        e.preventDefault();
        selectTier(label);
      });
    }

    // ============ FBT ACCESSORY TOGGLE (delegated, survives re-render) ============
    if (fbtEl) {
      fbtEl.addEventListener('click', function (e) {
        var cb = e.target.closest('.fbt-cb');
        if (!cb || cb.disabled) return;
        var row = cb.closest('.fbt-row');
        var acc = row && row.getAttribute('data-acc');
        if (!acc) return;
        optChecked[acc] = !optChecked[acc];
        renderFbt();
      });
    }

    // ============ UGC SLIDER ============
    (function () {
      var track = root.querySelector('[data-ugc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-ugc-prev]');
      var next = root.querySelector('[data-ugc-next]');
      function step() { var c = track.querySelector('.ugc-card'); return c ? c.getBoundingClientRect().width + 14 : 230; }
      function upd() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 1.5, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 1.5, behavior: 'smooth' }); });
      track.addEventListener('scroll', upd, { passive: true });
      upd();
    })();

    // ============ CART: add each REAL component variant (+ free gifts) ============
    // Bundle tier -> add each item variant AND each gift variant (qty 1). Free gifts
    // are added at their normal price here (no synthetic $0 line); a Shopify Function
    // discount handles the bundle pricing at checkout on the live store.
    function variantOf(h) { return P[h] && P[h].variant; }

    // The variants that a tier represents in the cart:
    //   - every component (item) variant once (single tier -> just the hero variant),
    //   - PLUS, on a bundle tier, each free-gift (wipes + headband) variant once.
    // Resolved entirely from the data-lrbp-model JSON (no hardcoded ids).
    function tierComponentIds(tier) {
      var ids = [];
      (tier.items || [handle]).forEach(function (h) { var v = variantOf(h); if (v) ids.push(v); });
      if (isBundleTier(tier)) {
        (tier.gifts && tier.gifts.length ? tier.gifts : giftHandlesFor()).forEach(function (h) {
          var v = variantOf(h); if (v) ids.push(v);
        });
      }
      return ids;
    }

    // Main CTA + sticky bar: add exactly the currently-selected tier.
    function addSelectedToCart() {
      if (!cartReady() || !selected) return Promise.resolve();
      return addSequential(tierComponentIds(selected));
    }

    // FBT block: bundle tier behaves like the main CTA (components + free gifts). On the single
    // tier the free-gift companions are optional paid add-ons, so only ticked ones are included.
    function addFbtToCart() {
      if (!cartReady() || !selected) return Promise.resolve();
      var tier = selected;
      var ids;
      if (isBundleTier(tier)) {
        ids = tierComponentIds(tier);
      } else {
        ids = [];
        (tier.items || [handle]).forEach(function (h) { var v = variantOf(h); if (v) ids.push(v); });
        giftHandlesFor().filter(function (h) { return (tier.items || [handle]).indexOf(h) === -1; })
          .forEach(function (h) { if (optChecked[h]) { var v = variantOf(h); if (v) ids.push(v); } });
      }
      return addSequential(ids);
    }

    // Add ids one after another (each is a real window.LumarayCart.add(variantId, 1)) so the
    // whole bundle lands atomically from the shopper's point of view and the drawer settles on
    // the final, complete cart. Returns a promise that resolves only after EVERY add has been
    // attempted; a single failed add does not abort the rest of the bundle.
    function addSequential(ids) {
      ids = ids.filter(Boolean);
      if (!ids.length) return Promise.resolve();
      var chain = Promise.resolve();
      ids.forEach(function (id) {
        chain = chain
          .then(function () { return window.LumarayCart.add(id, 1); })
          .catch(function () { /* keep adding the remaining tier variants */ });
      });
      return chain;
    }

    // ============ MAIN CTA micro-interaction + cart ============
    if (cta) {
      var ctaLabel = cta.querySelector('.label');
      var ctaResetTimer = null;
      cta.addEventListener('click', function () {
        if (cta.classList.contains('is-loading') || cta.disabled) return;
        clearTimeout(ctaResetTimer);
        cta.classList.add('is-loading');
        cta.classList.remove('is-done');
        Promise.resolve(addSelectedToCart()).then(function () {
          cta.classList.remove('is-loading');
          cta.classList.add('is-done');
          if (ctaLabel) ctaLabel.textContent = 'Added to cart';
          ctaResetTimer = setTimeout(function () {
            cta.classList.remove('is-done');
            if (ctaLabel) ctaLabel.textContent = 'Add to cart';
          }, 2200);
        }).catch(function () {
          cta.classList.remove('is-loading');
          if (ctaLabel) ctaLabel.textContent = 'Add to cart';
        });
      });
    }

    // ============ FBT ADD button (delegated, survives re-render) ============
    var fbtDoneTimer = null;
    if (fbtEl) {
      fbtEl.addEventListener('click', function (e) {
        var btn = e.target.closest('#lrbpFbtAdd');
        if (!btn) return;
        clearTimeout(fbtDoneTimer);
        var label = btn.querySelector('.fa-label');
        var count = btn.querySelector('[data-fbt-count]');
        btn.classList.add('is-done');
        if (label) label.textContent = 'Added to cart';
        if (count) count.textContent = '';
        Promise.resolve(addFbtToCart()).then(function () {
          fbtDoneTimer = setTimeout(function () { btn.classList.remove('is-done'); renderFbt(); }, 2000);
        });
      });
    }

    // ============ STICKY ADD BAR ============
    var sticky = document.querySelector('.lr-stickybar[data-sticky-for="' + handle + '"]');
    function updateSticky(tier, tv) {
      if (!sticky) return;
      var nowEl = sticky.querySelector('[data-sticky-now]');
      var wasEl = sticky.querySelector('[data-sticky-was]');
      if (nowEl) nowEl.textContent = money(tier.price);
      if (wasEl) { wasEl.textContent = tv.save > 0 ? money(tv.was) : ''; wasEl.style.display = tv.save > 0 ? '' : 'none'; }
    }
    if (sticky) {
      var stickyCta = sticky.querySelector('[data-sticky-cta]');
      if (stickyCta) stickyCta.addEventListener('click', function () { addSelectedToCart(); });
      // reveal the bar once the main CTA has scrolled out of view
      var anchor = cta || root;
      if ('IntersectionObserver' in window && anchor) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var on = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', on);
            // let the CRO teaser lift above the bar (all devices); expose the bar height
            document.body.classList.toggle('lr-bar-on', on);
            if (on) document.body.style.setProperty('--lr-bar-h', sticky.offsetHeight + 'px');
          });
        }, { threshold: 0 });
        io.observe(anchor);
      }
    }

    // initial sync (server render already correct; this keeps JS state aligned)
    if (selected) applyPrice(selected);
    renderFbt();
  }

  // Smooth open/close animation for the Product details accordions (native <details>),
  // consistent across every product page. Height + fade, with transitionend + timeout fallback.
  function initAccordions(root) {
    var dets = (root || document).querySelectorAll('.lrbp .accordion details');
    Array.prototype.forEach.call(dets, function (det) {
      if (det.__accWired) return;
      var summary = det.querySelector('summary');
      var body = det.querySelector('.acc-body');
      if (!summary || !body) return;
      det.__accWired = true;
      body.style.overflow = 'hidden';
      var EASE = 'cubic-bezier(.4,0,.1,1)';
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (det.__accAnim) return;
        det.__accAnim = true;
        if (!det.open) {
          det.open = true;                       // render content so we can measure it
          body.style.height = '0px'; body.style.opacity = '0';
          var target = body.scrollHeight;
          void body.offsetHeight;                // reflow so the transition has a start value
          body.style.transition = 'height .34s ' + EASE + ',opacity .3s ease';
          body.style.height = target + 'px'; body.style.opacity = '1';
          var fin = function () { body.style.transition = ''; body.style.height = 'auto'; body.style.opacity = ''; det.__accAnim = false; };
          var te = function (ev) { if (ev.propertyName === 'height') { body.removeEventListener('transitionend', te); fin(); } };
          body.addEventListener('transitionend', te);
          setTimeout(function () { if (det.__accAnim) { body.removeEventListener('transitionend', te); fin(); } }, 460);
        } else {
          var cur = body.scrollHeight;
          body.style.height = cur + 'px'; body.style.opacity = '1';
          void body.offsetHeight;
          body.style.transition = 'height .3s ' + EASE + ',opacity .22s ease';
          body.style.height = '0px'; body.style.opacity = '0';
          var finC = function () { det.open = false; body.style.transition = ''; body.style.height = ''; body.style.opacity = ''; det.__accAnim = false; };
          var teC = function (ev) { if (ev.propertyName === 'height') { body.removeEventListener('transitionend', teC); finC(); } };
          body.addEventListener('transitionend', teC);
          setTimeout(function () { if (det.__accAnim) { body.removeEventListener('transitionend', teC); finC(); } }, 420);
        }
      });
    });
  }

  // Rotating reassurance card under the Afterpay line: fade between the trust slides.
  function initUsp(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-usp]'), function (usp) {
      if (usp.__uspInit) return;
      var slides = usp.querySelectorAll('.lr-usp__slide');
      if (slides.length < 2) return;
      usp.__uspInit = true;
      var i = 0, timer = null;
      function tick() { slides[i].classList.remove('is-active'); i = (i + 1) % slides.length; slides[i].classList.add('is-active'); }
      function start() { if (!timer && !reduce) timer = setInterval(tick, 3200); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      usp.addEventListener('mouseenter', stop);
      usp.addEventListener('mouseleave', start);
      start();
    });
  }

  function boot() {
    var roots = document.querySelectorAll('.lrbp[data-handle]');
    Array.prototype.forEach.call(roots, init);
    initAccordions(document);
    initUsp(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
